module.exports = __webpack_public_path__ + "img/pigs-3.d6da8221.png";